import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clienti from './pages/Clienti';
import Servizi from './pages/Servizi';
import Preventivi from './pages/Preventivi';
import NuovoPreventivo from './pages/NuovoPreventivo';
import DettaglioPreventivo from './pages/DettaglioPreventivo';
import ModificaPreventivo from './pages/ModificaPreventivo';
import Impostazioni from './pages/Impostazioni';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Public Route Component (redirect to dashboard if already logged in)
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clienti"
        element={
          <ProtectedRoute>
            <Clienti />
          </ProtectedRoute>
        }
      />
      <Route
        path="/servizi"
        element={
          <ProtectedRoute>
            <Servizi />
          </ProtectedRoute>
        }
      />
      <Route
        path="/preventivi"
        element={
          <ProtectedRoute>
            <Preventivi />
          </ProtectedRoute>
        }
      />
      <Route
        path="/preventivi/nuovo"
        element={
          <ProtectedRoute>
            <NuovoPreventivo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/preventivi/:id"
        element={
          <ProtectedRoute>
            <DettaglioPreventivo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/preventivi/:id/modifica"
        element={
          <ProtectedRoute>
            <ModificaPreventivo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/impostazioni"
        element={
          <ProtectedRoute>
            <Impostazioni />
          </ProtectedRoute>
        }
      />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
